<template>
  <v-dialog v-model="dialog" max-width="600" persistent="persistent">
    <v-card class="px-4 pt-4 pb-4">
      <v-card-title>
          <h2>
              {{ title }}
          </h2>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap py-2 px-4>
          <v-flex xs12>
            <v-form row wrap ref="form">
              <v-layout row wrap>
                  <v-flex xs4 pt-4>
                      <strong class="subtitle">
                          Sin información
                      </strong>
                  </v-flex>
                  <v-flex xs4 pt-4>
                      <strong class="indicator">
                          >
                      </strong>
                  </v-flex>
                  <v-flex xs4>
                      <v-text-field
                      v-model="form.no_information"
                      label="Sin información"
                      color="black">
                      </v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout row wrap>
                  <v-flex xs4 pt-4>
                      <strong class="subtitle">
                          Contenido
                      </strong>
                  </v-flex>
                  <v-flex xs4 pt-4>
                      <strong class="indicator">
                          >
                      </strong>
                  </v-flex>
                  <v-flex xs4>
                      <v-text-field
                      v-model="form.content"
                      label="Contenido"
                      color="black">
                      </v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout row wrap>
                  <v-flex xs4 pt-4>
                      <strong class="subtitle">
                          Mejorado
                      </strong>
                  </v-flex>
                  <v-flex xs4 pt-4>
                      <strong class="indicator">
                          >
                      </strong>
                  </v-flex>
                  <v-flex xs4>
                      <v-text-field
                      v-model="form.improved"
                      label="Mejorado"
                      color="black">
                      </v-text-field>
                  </v-flex>
              </v-layout>
              <v-layout row wrap>
                  <v-flex xs4 pt-4>
                      <strong class="subtitle">
                          No contenido
                      </strong>
                  </v-flex>
                  <v-flex xs4 pt-4 class="indicator">
                      <strong >
                          >
                      </strong>
                  </v-flex>
                  <v-flex xs4>
                      <v-text-field
                      v-model="form.no_content"
                      label="No contenido"
                      color="black">
                      </v-text-field>
                  </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.prevent="closeModal()">Cancelar</v-btn>
        <v-btn class="k-orange-linear-text" flat @click.prevent="update()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/event-bus';

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {
        no_information: '',
        content: '',
        improved: '',
        no_content: '',
      },

      type: null,
    };
  },

  created() {
    EventBus.$on('data_edit_deliquency', (data) => {
      this.form.no_information = data[0].mask != null ? data[0].mask : data[0].delinquency_status;
      this.form.content = data[1].mask != null ? data[1].mask : data[1].delinquency_status;
      this.form.improved = data[2].mask != null ? data[2].mask : data[2].delinquency_status;
      this.form.no_content = data[3].mask != null ? data[3].mask : data[3].delinquency_status;

      this.type = 1;
    });

    EventBus.$on('data_edit_tranche', (data) => {
      this.form.no_information = data[0].mask != null ? data[0].mask : data[0].tranche_status;
      this.form.content = data[1].mask != null ? data[1].mask : data[1].tranche_status;
      this.form.improved = data[2].mask != null ? data[2].mask : data[2].tranche_status;
      this.form.no_content = data[3].mask != null ? data[3].mask : data[3].tranche_status;

      this.type = 2;
    });
  },

  methods: {
    closeModal() {
      this.$emit('closeModal', false);
    },

    update() {
      if (this.type < 2) {
        this.$emit('updateDeliquency', this.form);
      } else {
        this.$emit('updatetranches', this.form);
      }

      this.closeModal();
    },
  },
};
</script>

<style>
.indicator {
  font-size: 18px;
  color: #ff7c64;
}
</style>



// WEBPACK FOOTER //
// src/components/containment_states/edit.vue